class ShoppableImage extends HTMLElement {
  constructor() {
    super();
    this.popup = this.querySelector('[data-popup]');
    this.closeButton = this.querySelector('[data-close]');
    this.hotspotButtons = this.querySelectorAll('.shoppable-image__hotspot-button');
    this.products = this.querySelectorAll('[data-product-index]');
  }

  connectedCallback() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.hotspotButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        const hotspotIndex = button.getAttribute('data-hotspot-index');
        this.openPopup(hotspotIndex);
      });
    });

    this.closeButton.addEventListener('click', () => {
      this.closePopup();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.popup.classList.contains('active')) {
        this.closePopup();
      }
    });
  }

  openPopup(hotspotIndex) {
    this.products.forEach((product) => {
      product.classList.remove('active');
    });

    const selectedProduct = this.querySelector('[data-product-index="' + hotspotIndex + '"]');
    if (selectedProduct) {
      selectedProduct.classList.add('active');
    }

    this.popup.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  closePopup() {
    this.popup.classList.remove('active');
    document.body.style.overflow = '';
  }
}

customElements.define('shoppable-image', ShoppableImage);